/* eslint-disable react-hooks/exhaustive-deps */
import { ReactNode } from "react"
import { Button, Card } from "react-bootstrap"
import HeaderCrud from "components/header/header-crud-component"
import { Footer } from "components/footer/footer-component"

type PropsCrud = {
    titlePage: string
    change: () => any
    children: {
        header?: ReactNode
        body: ReactNode
        footer?: ReactNode
    }
}

const ChangeUserInternalCompanyPage: React.FC<PropsCrud> = ({ titlePage, change, children }: PropsCrud) => {
    

    return (
        <>
            <div style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
                <HeaderCrud title={titlePage} >
                    <div>
                        <Button variant="primary" onClick={change} size="sm">Trocar</Button>
                    </div>
                </HeaderCrud>
                <div className="mx-1" style={{flex: 1}}>
                    <Card>
                        <Card.Body>
                            {children.body}
                        </Card.Body>
                    </Card>
                </div>
                <Footer />
            </div>
        </>
    )

}

export default ChangeUserInternalCompanyPage